namespace e5 {
    export interface FocusOptions extends ActorOptions {
    }

    export class Focus extends Actor<Pointer, FocusOptions> implements FocusOptions {
        public static DEFAULT: FocusOptions = {
        };

        public onFocus = e5.Signal.create<[Pointer[], Focus]>();
        public onBlur = e5.Signal.create<[Pointer[], Focus]>();
        public onToggleFocus = e5.Signal.create<[boolean, Pointer[], Focus]>();

        private _focused: boolean = false;
        private _clickOutside: (e: Event) => void;

        constructor(element: HTMLElement = null, options: ClickOptions = null) {

            super(null, ActorNonOptions);

            if (options !== ActorNonOptions)
                this.setOptions(options);

            this.element = element;

            this.onDown.add(() => {
                this.focused = true;
            });

            this._clickOutside = (e) => {
                if (!this.focused)
                    return;
                var target = e.target as any;
                if (this.element != target && !this.element.contains(target)) {
                    this.focused = false;
                }
            };
        }

        public get focused(): boolean {
            return this._focused;
        }

        public set focused(focused: boolean) {
            if (this._focused === focused)
                return;
            this._focused = focused;
            if (focused) {
                document.addEventListener("mousedown", this._clickOutside);
                document.addEventListener("touchstart", this._clickOutside);
            } else {
                document.removeEventListener("mousedown", this._clickOutside);
                document.removeEventListener("touchstart", this._clickOutside);
            }
            if (focused)
                this.onFocus.dispatch(this.pointers, this);
            else
                this.onBlur.dispatch(this.pointers, this);
            this.onToggleFocus.dispatch(focused, this.pointers, this);
        }

        public focus(): void {
            this.focused = true;
        }

        public blur(): void {
            this.focused = false;
        }

        public setOptions(options: FocusOptions) {
            options = ObjectUtil.extend({}, Focus.DEFAULT, options);
            super.setOptions(options);
        }

        public dispose(): void {
            this.onFocus.dispose();
            this.onFocus = null;
            this.onBlur.dispose();
            this.onBlur = null;
            super.dispose();
        }
    }
}